import gql from 'graphql-tag';

export const CREATE_NEWSLETTER_SUBSCRIPTION = gql`
  mutation CreateNewsletterSubscription($input: CreateNewsletterSubscriptionInput!) {
    createNewsletterSubscription(input: $input) {
      success
      message
      code
      reason
    }
  }
`;

export const UPDATE_NEWSLETTER_SUBSCRIPTION = gql`
  mutation UpdateNewsletterSubscription($input: UpdateNewsletterSubscriptionInput!) {
    updateNewsletterSubscription(input: $input) {
      success
      message
      reason
    }
  }
`;

export const REQUEST_NEWSLETTER_SUBSCRIPTION_MAGIC_LINK = gql`
  mutation RequestNewsletterSubscriptionMagicLink($email: String!) {
    requestNewsletterSubscriptionMagicLink(email: $email) {
      success
      message
      code
      reason
    }
  }
`;

export const VERIFY_NEWSLETTER_SUBSCRIPTION_EMAIL = gql`
  mutation VerifyNewsletterSubscriptionEmail($token: String!) {
    verifyNewsletterSubscriptionEmail(token: $token) {
      success
      message
      code
      reason
    }
  }
`;


export const GET_NEWSLETTER_SUBSCRIPTION_BY_TOKEN = gql`
  query GetNewsletterSubscriptionByToken($magic_token: String!) {
    newsletterSubscriptionByToken(magic_token: $magic_token) {
      id
      frequency
      categories {
        id
      }
      user {
        id
        first_name
        last_name
        email_verified_at
        language
        email
        timezone
      }  
    }
  }
`;

export const DELETE_NEWSLETTER_SUBSCRIPTION = gql`
  mutation DeleteNewsletterSubscription($magic_token: String!) {
    deleteNewsletterSubscription(magic_token: $magic_token) {
      success
      message
      code
      reason
    }
  }
`;


export const REQUEST_NEWSLETTER_SUBSCRIPTION_VERIFICATION_EMAIL = gql`
  mutation RequestNewsletterSubscriptionVerificationEmail($email: String!) {
    requestNewsletterSubscriptionEmailVerification(email: $email) {
      success
      message
      code
      reason
    }
  }
`;
